import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { useTheme } from "styled-components";
import { useHistory } from "react-router-dom";
import { Button, Card, Icon, Picture, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { workingStylePublicUrl } from "~/lib/helpers";
const Content = styled.div`
  flex-grow: 1;
`;
const MessageButton = styled(Button)`
  word-break: break-all;
`;
const WorkingStyleMemberCard = _ref => {
  let {
    workingStyle,
    ...rest
  } = _ref;
  const {
    colors
  } = useTheme();
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const handleView = () => {
    history.push(workingStylePublicUrl(workingStyle, true));
  };
  const handleMessage = e => {
    e.stopPropagation();
    window.open(`mailto:${workingStyle.email}`, "_blank");
  };
  return /*#__PURE__*/React.createElement(Card, _extends({
    shadow: true,
    align: "center",
    onClick: handleView,
    minHeight: "20rem"
  }, rest), workingStyle.picture ? /*#__PURE__*/React.createElement(Picture, {
    src: workingStyle.picture,
    name: workingStyle.firstName,
    width: "7rem",
    height: "7rem",
    border: "circled",
    s: {
      mb: 4,
      mt: 6
    }
  }) : /*#__PURE__*/React.createElement(Text, {
    fontSize: 25,
    lineHeight: 25,
    s: {
      mb: 4,
      mt: 6
    }
  }, workingStyle.selectedEmoji), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 5,
    lineHeight: 6
  }, workingStyle.firstName), workingStyle.pronouns && /*#__PURE__*/React.createElement(Text, {
    element: "span",
    color: "textSecondary",
    fontSize: 3
  }, workingStyle.pronouns)), /*#__PURE__*/React.createElement(MessageButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("MemberCard.writeMessage"),
    color: "transparent",
    onClick: handleMessage,
    s: {
      mt: 2,
      mb: 2,
      py: 2,
      px: 4
    },
    fontSize: 3.5
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "mail",
    color: colors.text.primary,
    s: {
      mr: 1
    }
  }), workingStyle.email));
};
export default WorkingStyleMemberCard;